import { Link } from 'react-router-dom';
import './TermsAndConditions.css'; 

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <h1>Politique de protection de la vie privée - UNIMATES</h1>

      <p>
        Chez UNIMATES, nous accordons une grande importance à la confidentialité de nos utilisateurs. 
        Voici nos politiques de confidentialité qui régissent la collecte, l'utilisation et la protection des informations personnelles des utilisateurs de notre plateforme.
      </p>

      <h2>1) Collecte d'informations :</h2>
      <p>
        UNIMATES peut collecter certaines informations personnelles des utilisateurs, telles que les noms, les adresses e-mail, les coordonnées et les préférences linguistiques, 
        dans le but de fournir et d'améliorer nos services. Ces informations sont collectées de manière volontaire et traitées conformément aux lois de protection des données applicables.
      </p>

      <h2>2) Utilisation des informations :</h2>
      <p>
        Nous utilisons les informations collectées pour permettre aux utilisateurs d'accéder à notre plateforme et à nos services, 
        ainsi que pour personnaliser leur expérience et améliorer la qualité de nos services. Nous pouvons également utiliser les informations pour envoyer des communications liées à nos services, 
        telles que des mises à jour et des notifications importantes.
      </p>

      <h2>3) Protection des informations :</h2>
      <p>
        UNIMATES s'engage à protéger les informations personnelles des utilisateurs et a mis en place des mesures de sécurité techniques et organisationnelles pour prévenir tout accès non autorisé, divulgation ou utilisation abusive.
      </p>

      <h2>4) Partage des informations :</h2>
      <p>
        Nous nous engageons à ne pas partager ces informations avec des tiers, sauf dans certains cas nécessaires pour fournir nos services, avec votre consentement explicite, ou pour des obligations légales.
      </p>

      <h2>5) Conservation des informations :</h2>
      <p>
        Nous conserverons les informations personnelles des utilisateurs pendant la durée nécessaire pour atteindre les objectifs pour lesquels elles ont été collectées, 
        sauf si la loi exige ou permet une période de conservation plus longue.
      </p>

      <h2>6) Droits des utilisateurs :</h2>
      <p>
        Vous bénéficiez de droits spécifiques en vertu du RGPD (accès, rectification, suppression, limitation, portabilité, opposition, retrait du consentement, dépôt de plainte auprès de la CNIL).
      </p>

      <h2>7) Utilisation de la caméra :</h2>
      <p>
        L'application UNIMATES utilise la caméra dans les situations suivantes : 
      </p>
      <ul>
        <li>Changer la photo de profil de l'utilisateur.</li>
        <li>Ajouter une image lors de la création de posts ou contenus par l'utilisateur.</li>
      </ul>
      <p>
        Ces usages sont uniquement destinés à améliorer votre expérience sur la plateforme et aucune donnée n'est partagée avec des tiers sans votre consentement.
      </p>

      <h2>8) Modifications de la politique :</h2>
      <p>
        UNIMATES se réserve le droit de modifier cette politique à tout moment. Les utilisateurs seront informés de tout changement important.
      </p>

      <h2>9) Contact :</h2>
      <p>
        Pour toute question ou demande concernant nos politiques de confidentialité : <a href="mailto:contact@unimates-online.com">contact@unimates-online.com</a>
      </p>

      <p>
        En utilisant la plateforme UNIMATES, vous acceptez les termes et conditions de cette politique de confidentialité.
      </p>

      <div style={{ marginTop: '20px' }}>
        <Link to="/">← Retour à l'accueil</Link>
      </div>
    </div>
  );
};

export default TermsAndConditions;
